import { abbreviateNumber } from '../../assets/helper/functions'
// eslint-disable-next-line import/order
import type {
  MetricAssignmentCompletionType,
  TargetParametersType,
  MetricAssignmentType,
  MetricValueType,
} from '~/types/types'
import { MetricValueKind, AnnualAggregationMethod } from '~/types/types'
import { handleUndefined } from '../common'
let years: any = []
let metricData: any = {}
export const handleMetricAssignmentInfo = (metricAssignment: MetricAssignmentType, MetricValues: MetricValueType[], locale, showTargetProgress?: boolean) => {
  if (metricAssignment) {
    const { completionStatus } = metricAssignment
    const { targetParameters } = completionStatus
    const score = computeProgressScore(completionStatus)
    const xPos = setPositionForProgressScore(String(score).length)
    const metricValues = MetricValues.filter((metricValue) => {
      const actual = metricValue?.actual === 0 ? '0' : metricValue?.actual
      const target = metricValue?.target === 0 ? '0' : metricValue?.target
      const quarterlyOrMonthly = metricValue?.period.includes('Q') || metricValue?.period.includes('M')
      if ((actual || target) && !quarterlyOrMonthly) return metricValue
    })
    const yearsLength = getMetricValuesData(metricValues)
    const calculationMessage = getCalculationMessage(completionStatus)
    const target = calculateTarget(completionStatus, locale)
    const actual = calculateActual(completionStatus, locale)

    if (yearsLength > 1 && metricAssignment.completionStatus?.hasTarget) {
      return [{
          margin: [15, 10, 0, 0],
          columns: [
              {
                columns: [
                  {
                    svg: `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.64062 8.42762L16.7195 1.99609" stroke="#8FA5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.9062 1L16.7253 1.9961L15.6764 4.64006" stroke="#8FA5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17.3906 17H14.1126L14.1126 8.3918C14.1126 8.22873 14.1817 8.07233 14.3047 7.95702C14.4276 7.84171 14.5944 7.77693 14.7682 7.77693H16.735C16.9089 7.77693 17.0757 7.84171 17.1986 7.95702C17.3216 8.07233 17.3906 8.22873 17.3906 8.3918V17Z" stroke="#8FA5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.8359 17H7.55796L7.55796 10.2364C7.55796 10.0734 7.62703 9.91696 7.74998 9.80165C7.87292 9.68634 8.03968 9.62156 8.21355 9.62156H10.1803C10.3542 9.62156 10.521 9.62156 10.6439 9.80165C10.7669 9.91696 10.8359 10.0734 10.8359 10.2364V17Z" stroke="#8FA5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.28125 17H1.00321L1.00321 12.081C1.00321 11.9179 1.07228 11.7616 1.19523 11.6462C1.31818 11.5309 1.48494 11.4662 1.65882 11.4662H3.62564C3.79952 11.4662 3.96628 11.5309 4.08923 11.6462C4.21218 11.7616 4.28125 11.9179 4.28125 12.081L4.28125 17Z" stroke="#8FA5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
                    width: 13,
                    height: 13,
                  },
                  {
                    text: handleUndefined(metricAssignment?.metricNameOverride),
                    width: 200,
                    style: ['metricName'],
                  },
                ],
              },
          ],
        },
        {
          text: handleUndefined(metricAssignment?.metric?.unitName),
          style: ['metricUnit'],
        },
        {
          margin: [0, 10, 0, 0],
          columns: [
            ...(Object.keys(metricData).length && showTargetProgress
        ? [{
            svg: `<svg width="370" height="78" viewBox="0 0 370 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.25" x="0" width="270" height="24" rx="10" fill="#8FA5AF"/>
            <rect width="${calculateProgressBarWidth(270, score || 0)}" x="1" y="1" height="22" rx="10" fill="#5188ff"/>
            ${completionStatus?.actual !== 0 ? `<text fill="#5B7185" font-family="Barlow" font-weight="bold" font-size="12" x="2" y="45.3">0</text>` : ''}
            <text fill="#5188ff" font-family="Barlow" font-weight="bold" font-size="12" x="${calculateActualPosition(score || 0, completionStatus?.actual ?? 0)}" y="45.3">${actual || '0'}</text>
            <text fill="#5B7185" font-family="Barlow" font-size="12" x="240" y="45.3">${target || '0'}</text>
            <text fill="#343F49" font-family="Barlow" font-size="12" x="27" y="70.8">${calculationMessage || ''}</text>
            <text fill="#5188ff" font-family="Barlow" font-size="20" font-weight="600" x="${xPos?.scoreX || 290}" y="20">${score || 0}%</text>
            </svg>`,
            fit: [250, 100],
            margin: [23, 0, 0, 0],
          }]
        : []),
        table(actual, target, metricValues, targetParameters, locale, showTargetProgress),]
        }
      ]
    }
  }
}

const calculateActual = (
  completionStatus: MetricAssignmentCompletionType,
  locale,
) => {
  const actual = completionStatus?.actual || 0
  return abbreviateNumber(Number(actual), locale)
}

const calculateTarget = (
  completionStatus: MetricAssignmentCompletionType,
  locale,
) => {
  if (completionStatus.hasTarget) {
    const { target } = completionStatus.targetParameters as TargetParametersType
    return abbreviateNumber(Number(target), locale)
  } else return 0
}

const computeProgressScore = (
  completionStatus: MetricAssignmentCompletionType,
) => {
  if (completionStatus.hasTarget) {
    const rate = completionStatus.completionRate as number
    return Math.round(rate * 100)
  } else return 0
}

const getCalculationMessage = (
  completionStatus: MetricAssignmentCompletionType,
) => {
  if (completionStatus.hasTarget) {
    const params = completionStatus.targetParameters as TargetParametersType
    if (params.calculationType === 'sum')
      return `Sum of values from ${params.startDate} - ${params.endDate}`
    else if (params.calculationType === 'average')
      return `Average of values from ${params.startDate} - ${params.endDate}`
    else if (params.calculationType === 'most_recent_value')
      return `Most recent value from ${params.startDate} - ${params.endDate}`
    else return ''
  } else return ''
}

const setPositionForProgressScore = (scoreLength: number) => {
  if (scoreLength === 1) return { scoreX: 290, lineX: 315, finalScoreX: 320 }
  else if (scoreLength === 2)
    return { scoreX: 290, lineX: 318, finalScoreX: 323 }
  else return { scoreX: 290, lineX: 330, finalScoreX: 335 }
}

const calculateActualPosition = (progressValue: number, actual: number) => {
  const width = calculateProgressBarWidth(270, progressValue)
  if (progressValue >= 0 && progressValue <= 6 && actual !== 0) return 13
  else if (progressValue >= 80) return 208
  else return actual !== 0 ? width - 5 : 2
}

const table = (
  actual,
  target,
  metricValues,
  targetParameters,
  locale = 'en',
  showTargetProgress?: Boolean
) => {
  let marginLeft = 20
  let marginTop = 0
  if (showTargetProgress) {
    marginLeft = -110
    marginTop = -25
  }
  return {
    layout: 'noBorders',
    margin: [marginLeft, marginTop, 0, 0],
    pageBreakBefore: (currentNode, followingNodesOnPage) => {
      // Calculate precise table height based on actual styles and content
      const headerRowHeight = 10 + 16 // fontSize + margins (8+8)
      const dataRowHeight = 10 + 6 // fontSize + margins (3+3)

      // Calculate content-based height adjustments
      const maxContentLength = Math.max(
        ...metricValues.map(v => String(v.actual || v.target || '').length),
        String(actual || '').length,
        String(target || '').length
      )

      // Add extra height for longer content (roughly 2px per 10 characters)
      const contentHeightAdjustment = Math.floor(maxContentLength / 10) * 2

      const estimatedTableHeight = (headerRowHeight + (dataRowHeight * 2)) + contentHeightAdjustment
      const remainingSpace = currentNode.pageInnerHeight - currentNode.y

      return remainingSpace < estimatedTableHeight
    },
    table: {
      headerRows: 1,
      widths: calculateWidth(metricValues),
      body: [
        getYearsInfo(targetParameters),
        getActualInfo(actual, locale),
        getTargetInfo(target, locale),
      ],
    },
  }
}
const calculateWidth = (metricValues) => {
  const widths: any = ['auto']
  const width = years.length === 12 ? 'auto' : 35
  metricValues.forEach((_e) => widths.push(width))
  widths.push(60)
  return widths
}

const getYearsInfo = (targetParameters) => {
  const { startDate, endDate } = targetParameters
  years.push(`${startDate}-${endDate}`)
  return years.map((year: string) => {
    const isTotalColumn = year.includes('-')
    return {
      text: year,
      style: isTotalColumn ? ['tableHeader', 'totalColumn'] : ['tableHeader'],
    }
  })
}

const getActualInfo = (actual, locale) => {
  return years.map((year: string) => {
    const isTotalColumn = year.includes('-')
    if (isTotalColumn) {
      return {
        text: getMetricActualValue(actual, year, locale),
        style: ['actualInfo', 'totalColumn'],
      }
    } else
      return {
        text: year.length
          ? getMetricActualValue(actual, year, locale)
          : 'actual',
        style: ['actual'],
      }
  })
}

const getTargetInfo = (target: number, locale) => {
  return years.map((year: string) => {
    const isTotalColumn = year.includes('-')
    return {
      text: year.length ? getMetricTargetValue(target, year, locale) : 'target',
      style: isTotalColumn ? ['target', 'totalColumn'] : ['target'],
    }
  })
}

export const calculateProgressBarWidth = (
  width: number,
  progressValue: number,
) => {
  if (progressValue > 100) progressValue = 100
  else if (progressValue === 1) progressValue = 1.6
  const percentageValue: number = progressValue ? progressValue / 100 : 0
  return width * percentageValue
}

const getMetricValuesData = (metricValues: any) => {
  years = []
  years.push('')
  if (metricValues.length) {
    metricData = {}
    metricValues.forEach((value: any) => {
      metricData[value.period] = {
        actual: value.actual,
        target: value.target,
      }
    })
    years.push(...Object.keys(metricData))
    return years.length
  }
}

const getMetricActualValue = (actual: number, key: string, locale = 'en') => {
  if (key.includes('-')) {
    return actual
  } else {
    let actualValue = metricData[key]?.actual
    actualValue = actualValue || 0
    return actualValue ? abbreviateNumber(Number(actualValue), locale) : '-'
  }
}

const getMetricTargetValue = (target: number, key, locale = 'en') => {
  if (key.includes('-')) {
    return target
  } else {
    key = Number(key)
    let targetValue = metricData[key]?.target
    targetValue = targetValue || 0
    return targetValue ? abbreviateNumber(Number(targetValue), locale) : 0
  }
}

type AggregatedPair = { actual: number | null, target: number | null }

const isComparableMetricType = (valueType?: MetricValueKind | null) => (
  valueType === MetricValueKind.Int
  || valueType === MetricValueKind.Float
  || valueType === MetricValueKind.Binary
)

const isAnnualPeriod = (period?: string | null) => !!period && !period.includes('Q') && !period.includes('M')

const normalizePeriods = (
  targetParameters: TargetParametersType | null | undefined,
  metricValues: MetricValueType[],
) => {
  const start = targetParameters?.startDate
  const end = targetParameters?.endDate
  if (
    start !== null
    && start !== undefined
    && end !== null
    && end !== undefined
    && end >= start
  ) {
    return Array.from({ length: end - start + 1 }, (_, i) => String(start + i))
  }

  const fallback = metricValues
    .map((v) => v.period)
    .filter((p): p is string => isAnnualPeriod(p))
  return Array.from(new Set(fallback)).sort((a, b) => Number(a) - Number(b))
}

const resolveAggregationType = (metricAssignment: MetricAssignmentType) => {
  const assignmentType = metricAssignment.customTargetCalculationType as AnnualAggregationMethod | null | undefined
  if (assignmentType) return assignmentType

  const legacy = metricAssignment?.completionStatus?.targetParameters?.calculationType
  if (legacy === 'average') return AnnualAggregationMethod.Avg
  if (legacy === 'most_recent_value') return AnnualAggregationMethod.MostRecent
  return AnnualAggregationMethod.Sum
}

const calculatePercentage = (
  actual: number | null | undefined,
  target: number | null | undefined,
  isComparable: boolean,
): string => {
  if (!isComparable) return '...'
  if (actual === null || actual === undefined || target === null || target === undefined) return '...'
  if (target === 0) return actual === 0 ? '100%' : '...'
  return `${Math.round((actual / target) * 100)}%`
}

const formatValue = (value: number | null | undefined, locale = 'en') => {
  if (value === null || value === undefined) return '...'
  return abbreviateNumber(Number(value), locale)
}

const getRawDisplayValue = (
  metricValue: MetricValueType | undefined,
  valueType: MetricValueKind | null | undefined,
  locale = 'en',
) => {
  if (!metricValue) return '...'
  if (isComparableMetricType(valueType)) return formatValue(metricValue.actual, locale)

  if (valueType === MetricValueKind.String) return metricValue.text || '...'
  if (valueType === MetricValueKind.Select || valueType === MetricValueKind.SingleSelect) {
    return (metricValue.options || []).length ? (metricValue.options || []).join(', ') : '...'
  }
  return '...'
}

const getAggregationLabel = (aggregationType: AnnualAggregationMethod) => {
  if (aggregationType === AnnualAggregationMethod.Avg) return 'Average'
  if (aggregationType === AnnualAggregationMethod.MostRecent) return 'Most recent'
  return 'Sum'
}

const computeAccumulatedByPeriod = (
  metricAssignment: MetricAssignmentType,
  periods: string[],
  valuesByPeriod: Record<string, MetricValueType>,
): Record<string, AggregatedPair> => {
  const result: Record<string, AggregatedPair> = {}
  const aggregationType = resolveAggregationType(metricAssignment)
  const valueType = metricAssignment?.metric?.valueType
  const shouldRoundIntAverages = valueType === MetricValueKind.Int

  let actualTotal = 0
  let targetTotal = 0
  let actualCount = 0
  let targetCount = 0
  let lastPair: AggregatedPair | null = null

  periods.forEach((period) => {
    const mv = valuesByPeriod[period]
    const hasActual = mv?.actual !== null && mv?.actual !== undefined
    const hasTarget = mv?.target !== null && mv?.target !== undefined

    if (aggregationType === AnnualAggregationMethod.MostRecent) {
      if (hasActual && hasTarget) {
        lastPair = { actual: Number(mv.actual), target: Number(mv.target) }
      }
      result[period] = lastPair ? { ...lastPair } : { actual: null, target: null }
      return
    }

    if (hasActual) {
      actualTotal += Number(mv.actual)
      actualCount += 1
    }
    if (hasTarget) {
      targetTotal += Number(mv.target)
      targetCount += 1
    }

    let actual: number | null = hasActual
      ? (aggregationType === AnnualAggregationMethod.Avg ? actualTotal / actualCount : actualTotal)
      : null
    let target: number | null = hasTarget
      ? (aggregationType === AnnualAggregationMethod.Avg ? targetTotal / targetCount : targetTotal)
      : null

    if (shouldRoundIntAverages && aggregationType === AnnualAggregationMethod.Avg) {
      actual = actual === null ? null : Math.round(actual)
      target = target === null ? null : Math.round(target)
    }

    result[period] = { actual, target }
  })

  return result
}

const cardBlock = (title: string, content: any, marginTop = 8) => ({
  margin: [0, marginTop, 0, 0],
  table: {
    widths: ['*'],
    body: [
      [
        {
          text: title,
          fillColor: '#f8fafc',
          bold: true,
          fontSize: 9,
          color: '#111827',
          margin: [10, 6, 10, 6],
          border: [true, true, true, true],
          borderColor: ['#d1d5db', '#d1d5db', '#d1d5db', '#d1d5db'],
        },
      ],
      [
        {
          stack: Array.isArray(content) ? content : [content],
          margin: [8, 8, 8, 8],
          border: [true, false, true, true],
          borderColor: ['#d1d5db', '#d1d5db', '#d1d5db', '#d1d5db'],
        },
      ],
    ],
  },
  layout: {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 0,
    paddingTop: () => 0,
    paddingBottom: () => 0,
  },
})

export const handleMetricAssignmentCard = (
  metricAssignment: MetricAssignmentType,
  metricValuesInput: MetricValueType[] = [],
  locale = 'en',
) => {
  if (!metricAssignment) return []

  const valueType = metricAssignment?.metric?.valueType
  const comparable = isComparableMetricType(valueType)
  const completionStatus = metricAssignment?.completionStatus
  const targetParameters = completionStatus?.targetParameters
  const annualMetricValues = (metricValuesInput || []).filter((v) => isAnnualPeriod(v?.period))
  const periods = normalizePeriods(targetParameters, annualMetricValues)
  const valuesByPeriod = annualMetricValues.reduce((acc: Record<string, MetricValueType>, mv) => {
    if (mv?.period) acc[mv.period] = mv
    return acc
  }, {})

  const hasTargets = annualMetricValues.some((mv) => mv?.target !== null && mv?.target !== undefined)
  const showTargetProgress = comparable && (completionStatus?.hasTarget || hasTargets)

  const aggregatedByPeriod = computeAccumulatedByPeriod(metricAssignment, periods, valuesByPeriod)
  const score = Math.max(0, Math.min(100, Math.round(Number(completionStatus?.completionRate || 0) * 100)))
  const aggregateLabel = getAggregationLabel(resolveAggregationType(metricAssignment))

  const headerCell = (text: string) => ({ text, bold: true, fontSize: 9, color: '#343F49', margin: [0, 3, 0, 3] })
  const bodyCell = (text: string) => ({ text, fontSize: 9, color: '#343F49', margin: [0, 2, 0, 2] })
  const accentCell = (text: string) => ({ text, fontSize: 9, color: '#1f6fb2', margin: [0, 2, 0, 2] })

  const metaParts = [
    `Unit: ${metricAssignment?.unitName || metricAssignment?.metric?.unitName || '-'}`,
    ...(periods.length ? [`Target window: ${periods[0]}-${periods[periods.length - 1]}`] : []),
    ...(
      metricAssignment?.completionStatus?.targetParameters?.weight !== null
      && metricAssignment?.completionStatus?.targetParameters?.weight !== undefined
        ? [`Weight: ${metricAssignment?.completionStatus?.targetParameters?.weight}%`]
        : []
    ),
  ]

  const cumulativeTable = {
    margin: [0, 6, 0, 0],
    layout: 'lightHorizontalLines',
    table: {
      headerRows: 1,
      widths: [120, ...periods.map(() => '*')],
      body: [
        [headerCell('Cumulative inputs by year'), ...periods.map((p) => headerCell(p))],
        [
          bodyCell('Actual values used'),
          ...periods.map((p) => bodyCell(formatValue(aggregatedByPeriod[p]?.actual, locale))),
        ],
        [
          bodyCell('Target values used'),
          ...periods.map((p) => bodyCell(formatValue(aggregatedByPeriod[p]?.target, locale))),
        ],
        [
          bodyCell('Per-year progress'),
          ...periods.map((p) => accentCell(calculatePercentage(
            aggregatedByPeriod[p]?.actual,
            aggregatedByPeriod[p]?.target,
            comparable,
          ))),
        ],
      ],
    },
  }

  const targetProgressCard = showTargetProgress
    ? [
      {
        columns: [
          {
            width: 175,
            stack: [
              { text: `Total actual: ${formatValue(completionStatus?.actual, locale)}`, style: 'messageBold' },
              { text: `Total target: ${formatValue(targetParameters?.target, locale)}`, style: 'messageBold', margin: [0, 2, 0, 0] },
              { text: 'Aggregation method:', style: 'messageBold', margin: [0, 6, 0, 0] },
              { text: aggregateLabel, color: '#1d4ed8', fontSize: 9, margin: [0, 2, 0, 0] },
              { text: `${score}%`, color: '#2563eb', bold: true, fontSize: 18, margin: [0, 8, 0, 0] },
            ],
          },
          {
            width: '*',
            stack: [
              {
                margin: [0, 2, 0, 0],
                canvas: [
                  { type: 'rect', x: 0, y: 0, w: 420, h: 14, r: 7, color: '#e5e7eb' },
                  { type: 'rect', x: 0, y: 0, w: calculateProgressBarWidth(420, score), h: 14, r: 7, color: '#5188ff' },
                ],
              },
              cumulativeTable,
            ],
          },
        ],
      },
    ]
    : []

  const rawValuesTable = {
    layout: 'lightHorizontalLines',
    table: {
      headerRows: 1,
      widths: [120, ...periods.map(() => '*')],
      body: [
        [headerCell('Values'), ...periods.map((p) => headerCell(p))],
        [
          bodyCell(comparable ? 'Actual' : 'Value'),
          ...periods.map((p) => {
            const mv = valuesByPeriod[p]
            return comparable
              ? bodyCell(formatValue(mv?.actual, locale))
              : bodyCell(getRawDisplayValue(mv, valueType, locale))
          }),
        ],
        ...(
          comparable
            ? [[
              bodyCell('Target'),
              ...periods.map((p) => bodyCell(formatValue(valuesByPeriod[p]?.target, locale))),
            ]]
            : []
        ),
        ...(
          comparable
            ? [[
              bodyCell('Per-year progress'),
              ...periods.map((p) => accentCell(calculatePercentage(valuesByPeriod[p]?.actual, valuesByPeriod[p]?.target, true))),
            ]]
            : []
        ),
      ],
    },
  }

  return {
    margin: [0, 12, 0, 0],
    stack: [
      {
        text: handleUndefined(metricAssignment?.metricNameOverride || metricAssignment?.metric?.name),
        bold: true,
        fontSize: 10,
        color: '#111827',
      },
      {
        text: metaParts.join(' | '),
        style: 'message',
        margin: [0, 3, 0, 0],
      },
      ...(showTargetProgress ? [cardBlock('Target Progress', targetProgressCard, 8)] : []),
      cardBlock('Raw values', rawValuesTable, showTargetProgress ? 8 : 10),
    ],
  }
}
